import React from "react";
import axios from "axios";
// import { useLocation } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import { Box, Group, Text, useMantineTheme, Avatar, Divider } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { safeValue, sqlDateToIsoDate, getObjectParam2, CustomerCategoryIcon } from "../../utils/globalFunctions";
import { canAccessSeeCustomersPhoneNumber, canAccessInvoiceDanBuktiBayar, stepsCanAccessInvoice, stepsCanAccessBuktiBayar, canAccessTandaTerima, stepsCanAccessTandaTerima } from "../../utils/accessing";

import PaperWrapper from "../../components/utilities/PaperWrapper";
import TanggalMasukProject from "../../components/utilities/TanggalMasukProject";
import NomorNota from "../../components/utilities/NomorNota";
import BarangCategory from "../../components/utilities/BarangCategory";
import BarangNama from "../../components/utilities/BarangNama";
import BarangKeluhan from "../../components/utilities/BarangKeluhan";
import BarangKelengkapan from "../../components/utilities/BarangKelengkapan";
import BarangFormCek from "../../components/utilities/BarangFormCek";
import BarangFormCekQC from "../../components/utilities/BarangFormCekQC";
import BarangProjectNotaFoto from "../../components/utilities/BarangProjectNotaFoto";
import MediaImageVideoCarousel from "../../components/utilities/MediaImageVideoCarousel";
import BarangDPBiaya from "../../components/utilities/BarangDPBiaya";
import DiskonBlock from "../../components/utilities/DiskonBlock";
import BarangDPBiayaMetode from "../../components/utilities/BarangDPBiayaMetode";
import RekomendasiPenerima from "../../components/utilities/RekomendasiPenerima";
import RekomendasiPenerimaInfo from "../../components/utilities/RekomendasiPenerimaInfo";
import ProjectNotaCatatan from "../../components/utilities/ProjectNotaCatatan";
import PriorityNota from "../../components/utilities/PriorityNota";
import JenisService from "../../components/utilities/JenisService";
import DateLinePengecekan from "../../components/utilities/DateLinePengecekan";
import DateLineSelesai from "../../components/utilities/DateLineSelesai";

import DeadlinePengecekan from "../../components/utilities/DeadlinePengecekan";
import DeadlineSelesai from "../../components/utilities/DeadlineSelesai";

import TandaTerimaComponent from "../../components/documents/pdf/renderer/TandaTerimaComponent";
import INVBBComponent from "../../components/documents/pdf/renderer/INVBBComponent";
import CustomerSignature from "../../components/utilities/CustomerSignature";

import PrintKelengkapanPDF from "../../components/utilities/PrintKelengkapanPDF";

const StepNota = ({
  stateURI1,
  stateUtilsRef,
  stateIsSequence = false,
  fnRefreshNotaIndex,
  fnRefreshHistory,
  fnClickPhoto,
  stateShowMediaQC = false,
  fnClickMediaImageVideo,
  fnCloseDrawer,
  fnRefreshStepSelesai
}) => {

  const mountedRef = React.useRef(true);

  // const history = useLocation();
  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetDataProject: 'projectNotaAdd-1',
  })

  const constProjectNotaCustomer = {
    id: 'addProjectNotaCustomer',
    label: 'Customer',
    withAsterisk: false,
    placeholder: 'Customer',
    value: {
      id: '',
      name: '',
      gender: '1',
      address: '',
      contact: '',
      signature: null,
      signatureName: '',
      categorySlug: '',
      categoryName: '',
      customerGroupId: '',
      customerGroupName: '',
      customerIdCardNumber: '',
      projectSequence: '',

      diskonId: '',
      diskonFlag: '',
      diskonName: '',
      diskonType: '',
      diskonValue: '',
      diskonDeductedFrom: '',
      diskonVoucherCode: ''
    },
    description: '',
    error: ''
  }

  const constProjectNotaNomor = {
    id: 'addProjectNotaNomor',
    label: 'Nomor Nota',
    withAsterisk: false,
    placeholder: 'Nomor Nota',
    value: {
      id: '',
      userCreatedName: '',
      userCreatedSubLevel: '',
      createdDateTime: ''
    },
    description: '',
    error: ''
  }

  const constProjectNotaTanggalMasuk = {
    id: 'addProjectNotaTanggalMasuk',
    label: 'Tanggal Masuk',
    withAsterisk: false,
    placeholder: 'Tanggal Masuk',
    value: new Date(),
    description: '',
    error: ''
  }

  const constProjectNotaBarangCategory = {
    id: 'addProjectNotaBarangCategory',
    label: 'Kategori Barang',
    withAsterisk: true,
    placeholder: 'Kategori Barang',
    value: {
      id: ''
    },
    description: '',
    error: ''
  }

  const constProjectNotaBarangNama = {
    id: 'addProjectNotaBarangNama',
    label: 'Nama Barang',
    withAsterisk: true,
    placeholder: 'Nama Barang',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaBarangKeluhan = {
    id: 'addProjectNotaBarangKeluhan',
    label: 'Keluhan / Kerusakan',
    withAsterisk: true,
    placeholder: 'Keluhan / Kerusakan',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaBarangKelengkapan = {
    id: 'addProjectNotaBarangKelengkapan',
    label: 'Kelengkapan Barang',
    withAsterisk: false,
    placeholder: 'Kelengkapan Barang',
    value: [],
    description: '',
    error: ''
  }

  const constProjectNotaBarangFormCek = {
    id: 'addProjectNotaBarangFormCek',
    label: 'Form Ceklis',
    withAsterisk: false,
    placeholder: 'Form Ceklis',
    value: {
      masterId: '',
      detil: []
    },
    description: '',
    error: ''
  }

  const constProjectQCBarangFormCek = {
    id: 'componentProjectQCBarangFormCek',
    label: 'Form Ceklis',
    withAsterisk: false,
    placeholder: 'Form Ceklis',
    value: {
      masterId: '',
      detil: []
    },
    description: '',
    error: ''
  }

  const constProjectNotaBarangFoto = {
    id: 'addProjectNotaBarangFoto',
    label: 'Foto Barang',
    withAsterisk: true,
    placeholder: 'Foto Barang',
    value: [],
    description: '',
    error: ''
  }

  const constProjectMediaQC = {
    id: 'addProjectMediaQC',
    label: 'Foto & Video Hasil QC',
    withAsterisk: false,
    placeholder: 'Foto & Video Hasil QC',
    value: [],
    description: '',
    error: ''
  }

  const constProjectNotaDPBiaya = {
    id: 'addProjectNotaDPBiaya',
    label: 'Uang Muka',
    withAsterisk: false,
    placeholder: 'Uang Muka',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaDPMetode = {
    id: 'addProjectNotaDPMetode',
    label: 'Metode Bayar',
    withAsterisk: false,
    placeholder: 'Metode Bayar',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaRekomendasiPengerjaan = {
    id: 'addProjectNotaRekomendasiPengerjaan',
    label: 'Rekomendasi Pengerjaan',
    withAsterisk: false,
    placeholder: 'Rekomendasi Pengerjaan',
    value: {
      id: '',
      name: '',
      gender: '',
      level: '',
      subLevel: '',
    },
    description: '',
    error: ''
  }

  const constProjectNotaRekomendasiCatatan = {
    id: 'addProjectNotaRekomendasiCatatan',
    label: 'Catatan Rekomendasi',
    withAsterisk: false,
    placeholder: 'Catatan Rekomendasi',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaCatatan = {
    id: 'addProjectNotaCatatan',
    label: 'Catatan Nota',
    withAsterisk: false,
    placeholder: 'Catatan Nota',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaProjectPriority = {
    id: 'addProjectNotaProjectPriority',
    label: 'Prioritas Project',
    withAsterisk: true,
    placeholder: 'Prioritas Project',
    value: '3',
    description: '',
    error: ''
  }

  const constProjectNotaDateLinePengecekan = {
    id: 'addProjectNotaDateLinePengecekan',
    label: 'Deadline Pengecekan',
    withAsterisk: true,
    placeholder: 'Deadline Pengecekan',
    value: new Date(),

    hasPengecekan: null,
    dateLine: null,
    today: null,

    description: '',
    error: ''
  }

  const constProjectNotaDateLineSelesai = {
    id: 'addProjectNotaDateLineSelesai',
    label: 'Deadline Selesai',
    withAsterisk: true,
    placeholder: 'Deadline Selesai',
    value: new Date(),

    tanggalSelesai: null,
    dateLine: null,
    today: null,

    description: '',
    error: ''
  }

  const [data, setData] = React.useState({
    projectDataInitLoading: false,
    projectDataFlag: 'idle',

    projectCustomer: constProjectNotaCustomer,
    projectNotaNomor: constProjectNotaNomor,
    projectNotaTanggalMasuk: constProjectNotaTanggalMasuk,

    projectNotaBarangCategory: constProjectNotaBarangCategory,
    projectNotaBarangNama: constProjectNotaBarangNama,
    projectNotaBarangKeluhan: constProjectNotaBarangKeluhan,

    projectNotaBarangKelengkapan: constProjectNotaBarangKelengkapan,

    projectNotaBarangFormCek: constProjectNotaBarangFormCek,
    projectQCBarangFormCek: constProjectQCBarangFormCek,

    projectNotaBarangFoto: constProjectNotaBarangFoto,

    projectMediaQC: constProjectMediaQC,

    projectNotaDPBiaya: constProjectNotaDPBiaya,
    projectNotaDPMetode: constProjectNotaDPMetode,

    projectNotaRekomendasiPengerjaan: constProjectNotaRekomendasiPengerjaan,
    projectNotaRekomendasiCatatan: constProjectNotaRekomendasiCatatan,

    projectNotaCatatan: constProjectNotaCatatan,
    projectNotaPriority: constProjectNotaProjectPriority,

    projectNotaDateLinePengecekan: constProjectNotaDateLinePengecekan,
    projectNotaDateLineSelesai: constProjectNotaDateLineSelesai,

    projectJenisService: {
      jenis: '',
      remind_in: ''
    },

    isEverSubmittedProgress: false,

    dataSelector: {
      barangCategory: [],
      barangFormCek: [],
      barangNamaSuggestion: [],
      teknisi: [],
      discountVoucher: []
    },
  });

  React.useEffect(() => {
    return () => {
      // mountedRef.current = false;
    }
  }, [])

  const setDataProject = ({ stateData, stateDataBarangCategory, stateDataBarangFormCek, stateDataTeknisi, stateDataBarangNamaSuggestion, stateDataDiscountVoucher, stateIsEverSubmittedProgress }) => {
    if (Array.isArray(stateData) && (stateData.length > 0)) {
      console.log(stateData);


      setData(d => ({
        ...d,
        projectDataFlag: true,

        isEverSubmittedProgress: stateIsEverSubmittedProgress,

        projectJenisService: {
          ...d.projectJenisService,
          jenis: safeValue(stateData[0].service_category, ''),
          remind_in: safeValue(stateData[0].remind_in_month, ''),
        },

        dataSelector: {
          ...d.dataSelector,
          barangCategory: stateDataBarangCategory,
          barangFormCek: stateDataBarangFormCek,
          barangNamaSuggestion: stateDataBarangNamaSuggestion,
          teknisi: stateDataTeknisi,
          discountVoucher: stateDataDiscountVoucher
        },
        projectCustomer: {
          ...d.projectCustomer,
          value: {
            ...d.projectCustomer.value,
            id: safeValue(stateData[0].customer_id, ''),
            name: safeValue(stateData[0].customer_name, '[Nama]'),
            gender: safeValue(stateData[0].customer_gender, '1'),
            address: safeValue(stateData[0].customer_address, '[Alamat]'),
            signature: safeValue(stateData[0].customer_signature, null),
            signatureName: safeValue(stateData[0].customer_signature_name, ''),
            contact: safeValue(stateData[0].customer_contact, '[Kontak]'),
            categorySlug: safeValue(stateData[0].customer_category_slug, ''),
            categoryName: safeValue(stateData[0].customer_category_name, ''),

            customerGroupId: safeValue(stateData[0].customer_group_id, ''),
            customerGroupName: safeValue(stateData[0].customer_group_name, ''),
            customerIdCardNumber: safeValue(stateData[0].customer_id_card_number, ''),
            projectSequence: safeValue(stateData[0].project_sequence, '-'),

            diskonId: safeValue(stateData[0].diskon_voucher_id, ''),
            diskonFlag: safeValue(stateData[0].diskon_voucher_flag, ''),
            diskonName: safeValue(stateData[0].diskon_voucher_name, ''),
            diskonType: safeValue(stateData[0].diskon_voucher_type, ''),
            diskonValue: safeValue(stateData[0].diskon_voucher_value, ''),
            diskonDeductedFrom: safeValue(stateData[0].diskon_deducted_from, ''),
            diskonVoucherCode: safeValue(stateData[0].diskon_voucher_code, ''),
          }
        },
        projectNotaNomor: {
          ...d.projectNotaNomor,
          value: {
            ...d.projectNotaNomor.value,
            id: safeValue(stateData[0].project_id, ''),
            userCreatedName: safeValue(stateData[0].project_created_user_name, ''),
            userCreatedSubLevel: safeValue(stateData[0].project_created_user_sub_level, ''),
            createdDateTime: stateData[0].project_created_datetime
          }
        },
        projectNotaTanggalMasuk: {
          ...d.projectNotaTanggalMasuk,
          value: sqlDateToIsoDate(safeValue(stateData[0].tanggal_nota, ''), new Date())
        },
        projectNotaBarangCategory: {
          ...d.projectNotaBarangCategory,
          value: {
            ...d.projectNotaBarangCategory.value,
            id: safeValue(stateData[0].barang_category_id, '')
          }
        },
        projectNotaBarangNama: {
          ...d.projectNotaBarangNama,
          value: safeValue(stateData[0].barang_nama, '')
        },
        projectNotaBarangKeluhan: {
          ...d.projectNotaBarangKeluhan,
          value: safeValue(stateData[0].barang_keluhan, '')
        },
        projectNotaBarangKelengkapan: {
          ...d.projectNotaBarangKelengkapan,
          value: stateData[0].barang_kelengkapan
        },
        projectNotaBarangFormCek: {
          ...d.projectNotaBarangFormCek,
          value: {
            ...d.projectNotaBarangFormCek.value,
            masterId: safeValue(stateData[0].barang_form_cek_id, ''),
            detil: stateData[0].barang_form_cek_detil,
          }
        },
        projectQCBarangFormCek: {
          ...d.projectQCBarangFormCek,
          value: {
            ...d.projectQCBarangFormCek.value,
            masterId: safeValue(stateData[0].barang_form_cek_id, ''),
            detil: stateData[0].barang_form_cek_detil,
          }
        },
        projectNotaBarangFoto: {
          ...d.projectNotaBarangFoto,
          value: stateData[0].barang_foto_nota
        },

        projectMediaQC: {
          ...d.projectMediaQC,
          value: stateData[0].qc_media
        },

        projectNotaDPBiaya: {
          ...d.projectNotaDPBiaya,
          value: Number(stateData[0].biaya_dp) === 0 ? '' : stateData[0].biaya_dp
        },
        projectNotaDPMetode: {
          ...d.projectNotaDPMetode,
          value: safeValue(stateData[0].biaya_dp_metode, '')
        },
        projectNotaRekomendasiPengerjaan: {
          ...d.projectNotaRekomendasiPengerjaan,
          value: {
            ...d.projectNotaRekomendasiPengerjaan.value,
            id: safeValue(stateData[0].recommendation_penerima_user_id, ''),
            name: safeValue(stateData[0].penerima_rekomendasi_nama, ''),
            gender: safeValue(stateData[0].penerima_rekomendasi_gender, ''),
            level: safeValue(stateData[0].penerima_rekomendasi_level, ''),
            subLevel: safeValue(stateData[0].penerima_rekomendasi_sub_level, ''),
          }
        },
        projectNotaRekomendasiCatatan: {
          ...d.projectNotaRekomendasiCatatan,
          value: safeValue(stateData[0].recommendation_info, '')
        },
        projectNotaCatatan: {
          ...d.projectNotaCatatan,
          value: safeValue(stateData[0].catatan_nota, '')
        },
        projectNotaPriority: {
          ...d.projectNotaPriority,
          value: safeValue(stateData[0].project_priority, '')
        },
        projectNotaDateLinePengecekan: {
          ...d.projectNotaDateLinePengecekan,
          value: stateData[0].date_line_pengecekan ? sqlDateToIsoDate(stateData[0].date_line_pengecekan, null) : null,

          today: stateData[0].today ? stateData[0].today : null,
          hasPengecekan: stateData[0].has_pengecekan ? stateData[0].has_pengecekan : null,
          dateLine: stateData[0].date_line_pengecekan ? stateData[0].date_line_pengecekan : null,
        },
        projectNotaDateLineSelesai: {
          ...d.projectNotaDateLineSelesai,
          value: stateData[0].date_line_selesai ? sqlDateToIsoDate(stateData[0].date_line_selesai, null) : null,
          today: stateData[0].today ? stateData[0].today : null,
          dateLine: stateData[0].date_line_selesai ? stateData[0].date_line_selesai : null,
          tanggalSelesai: stateData[0].tanggal_selesai ? stateData[0].tanggal_selesai : null,
        },
      }))
    }
  }

  React.useEffect(() => {
    if (stateURI1) {

      setData(d => ({
        ...d,
        projectDataInitLoading: true,

        projectCustomer: { ...d.projectCustomer, error: '' },
        projectNotaNomor: { ...d.projectNotaNomor, error: '' },
        projectNotaTanggalMasuk: { ...d.projectNotaTanggalMasuk, error: '' },
        projectNotaBarangCategory: { ...d.projectNotaBarangCategory, error: '' },
        projectNotaBarangNama: { ...d.projectNotaBarangNama, error: '' },
        projectNotaBarangKeluhan: { ...d.projectNotaBarangKeluhan, error: '' },
        projectNotaBarangFoto: { ...d.projectNotaBarangFoto, error: '' },
        projectMediaQC: { ...d.projectMediaQC, error: '' },
        projectNotaPriority: { ...d.projectNotaPriority, error: '' },
        projectNotaDPMetode: { ...d.projectNotaDPMetode, error: '' },
      }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('flag_all', utils.flagAll);
      formDT.append('project_id', stateURI1);
      formDT.append('project_process', stateUtilsRef.projectProcess);
      formDT.append('project_is_cancel', stateUtilsRef.projectIsCancel);
      formDT.append('project_process_sudah_diambil', utils.projectProcess.sudah_diambil.value);
      formDT.append('project_progress_submitted_flag', utils.pengerjaanProgress.disubmit.value);

      axios({
        method: 'post',
        url: BE_API_TWO + '/select_project_by_project_id__project_antrian',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, projectDataInitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setDataProject({
            stateData: response.data.data_project,
            stateDataBarangCategory: response.data.data_barang_category,
            stateDataBarangFormCek: response.data.data_barang_form_cek,
            stateDataTeknisi: response.data.data_teknisi,
            stateDataBarangNamaSuggestion: response.data.data_barang_name_suggestion,
            stateDataDiscountVoucher: response.data.data_discount_voucher,
            stateIsEverSubmittedProgress: response.data.data_isset_submitted_progress
          });
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorGetDataProject,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            projectDataFlag: false
          }));
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          projectDataInitLoading: false
        }))

        notifications.show({
          id: notificationId.current.errorGetDataProject,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext, loginContext.syswebapp, stateURI1, stateUtilsRef.projectProcess, stateUtilsRef.projectIsCancel])

  return (
    <React.Fragment>
      {data.projectDataInitLoading &&
        <PaperWrapper mb='lg'>
          <Text size='sm' color="dimmed">Loading Data Nota..</Text>
        </PaperWrapper>
      }

      {!data.projectDataInitLoading && (data.projectDataFlag === false) &&
        <Text color="dimmed" align="center" py='2rem'>No Data</Text>
      }

      {!data.projectDataInitLoading && (data.projectDataFlag === true) &&
        <Box>
          <Box mb='1rem'>
            <PaperWrapper>
              <Group align='flex-start'>
                <Avatar
                  radius="xl"
                  size='1.75rem'
                  styles={(tema) => ({
                    placeholder: {
                      backgroundColor: tema.fn.rgba((theme.colorScheme === 'light' ? getObjectParam2(utils.priority, String(data.projectNotaPriority.value), 'colorBgLight', tema.colors.gray[1]) : getObjectParam2(utils.priority, String(data.projectNotaPriority.value), 'colorBgDark', tema.colors.dark[5])), 0.75)
                    }
                  })}
                >
                  {stateIsSequence ?
                    <div style={{ color: '#fff', fontWeight: '500', fontSize: '.75rem' }}>
                      {data.projectCustomer.value.projectSequence ? data.projectCustomer.value.projectSequence : '-'}
                    </div>
                    :
                    <CustomerCategoryIcon
                      stateCustomerCategory={data.projectCustomer.value.categorySlug}
                      stateSize='1.25rem'
                      stateColor={theme.colorScheme === 'light' ? '#fff' : '#fff'}
                    />
                  }
                </Avatar>

                <Box>
                  <Text size="sm" fw={500}>
                    {data.projectCustomer.value.name}
                  </Text>

                  <Text size="xs">
                    {data.projectCustomer.value.categoryName} {canAccessSeeCustomersPhoneNumber({ stateObject: { subLevel: loginContext } }) ? <>&bull; {data.projectCustomer.value.contact ? data.projectCustomer.value.contact : '[Contact]'}</> : ''}
                  </Text>

                  <Text size="xs">
                    {data.projectCustomer.value.customerGroupName ? data.projectCustomer.value.customerGroupName : '[Customer Group]'} &bull; {data.projectCustomer.value.customerIdCardNumber ? data.projectCustomer.value.customerIdCardNumber : '[Id Card]'}
                  </Text>

                  <Text size="xs">
                    {data.projectCustomer.value.address}
                  </Text>
                </Box>
              </Group>
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <NomorNota
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaNomor
                }}

                fnSuccessBatalNota={() => {
                  fnCloseDrawer();
                  fnRefreshNotaIndex();
                }}
              />
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <Box mb='1rem'>
                <BarangCategory
                  stateData={{
                    customerId: data.projectCustomer.value.id,
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectNotaBarangCategory,
                    dataBarangCategory: data.dataSelector.barangCategory
                  }}

                  fnOnChange={(val, arrSuggest) => {
                    setData(d => ({
                      ...d,
                      dataSelector: {
                        ...d.dataSelector,
                        barangNamaSuggestion: arrSuggest
                      },
                      projectNotaBarangCategory: {
                        ...d.projectNotaBarangCategory,
                        value: {
                          ...d.projectNotaBarangCategory.value,
                          id: val
                        }
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </Box>

              <Box mb='1rem'>
                <BarangNama
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectNotaBarangNama,
                    barangNamaSuggestion: data.dataSelector.barangNamaSuggestion
                  }}

                  fnOnChange={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangNama: {
                        ...d.projectNotaBarangNama,
                        value: val
                      }
                    }))
                    fnRefreshNotaIndex();
                    fnRefreshHistory();
                  }}
                />
              </Box>

              <BarangKeluhan
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaBarangKeluhan,
                }}

                fnOnChange={(val) => {
                  setData(d => ({
                    ...d,
                    projectNotaBarangKeluhan: {
                      ...d.projectNotaBarangKeluhan,
                      value: val
                    }
                  }))
                  fnRefreshNotaIndex();
                }}
              />
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <BarangKelengkapan
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaBarangKelengkapan,
                  barangNama: data.projectNotaBarangNama.value,
                  kerusakan: data.projectNotaBarangKeluhan.value,
                  customer: data.projectCustomer.value.name,
                  tanggalMasuk: data.projectNotaTanggalMasuk.value,
                }}

                fnOnChange={(array) => {
                  setData(d => ({
                    ...d,
                    projectNotaBarangKelengkapan: {
                      ...d.projectNotaBarangKelengkapan,
                      value: array
                    }
                  }))
                  // fnRefreshNotaIndex();
                }}
              />
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              {[utils.projectProcess.qc.value, utils.projectProcess.selesai.value, utils.projectProcess.sudah_diambil.value].includes(stateUtilsRef.projectProcess) ?
                <React.Fragment>
                  <BarangFormCekQC
                    stateData={{
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: stateUtilsRef.projectProcess,
                      projectIsCancel: stateUtilsRef.projectIsCancel,
                      userAccess: stateUtilsRef.userAccess,

                      data: data.projectNotaBarangFormCek,
                      dataBarangFormCek: data.dataSelector.barangFormCek
                    }}

                    fnOnChangeMaster={() => { }}

                    fnOnChangeDetil={(arrayDetil) => {
                      setData(d => ({
                        ...d,
                        projectNotaBarangFormCek: {
                          ...d.projectNotaBarangFormCek,
                          value: {
                            ...d.projectNotaBarangFormCek.value,
                            detil: arrayDetil
                          }
                        }
                      }))
                      // fnRefreshNotaIndex();
                    }}
                  />
                </React.Fragment>
                :
                <BarangFormCek
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectNotaBarangFormCek,
                    dataBarangFormCek: data.dataSelector.barangFormCek
                  }}

                  fnOnChangeMaster={(valMaster, valDetil) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangFormCek: {
                        ...d.projectNotaBarangFormCek,
                        value: {
                          ...d.projectNotaBarangFormCek.value,
                          masterId: valMaster,
                          detil: valDetil
                        }
                      }
                    }))
                    // fnRefreshNotaIndex();
                  }}

                  fnUpdateDetil={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangFormCek: {
                        ...d.projectNotaBarangFormCek,
                        value: {
                          ...d.projectNotaBarangFormCek.value,
                          detil: val
                        }
                      }
                    }))
                  }}

                  fnOnChangeDetil={(arrayDetil) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangFormCek: {
                        ...d.projectNotaBarangFormCek,
                        value: {
                          ...d.projectNotaBarangFormCek.value,
                          detil: arrayDetil
                        }
                      }
                    }))
                    // fnRefreshNotaIndex();
                  }}
                />
              }

              {data.isEverSubmittedProgress &&
                <MediaImageVideoCarousel
                  stateMT='2.5rem'
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectMediaQC,
                  }}

                  fnOnChange={(array) => {
                    setData(d => ({
                      ...d,
                      projectMediaQC: {
                        ...d.projectMediaQC,
                        value: array
                      }
                    }))
                    // fnRefreshNotaIndex();
                  }}

                  fnClickMedia={(object) => fnClickMediaImageVideo(object)}
                />
              }
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <BarangProjectNotaFoto
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaBarangFoto,
                }}

                fnOnChange={(array) => {
                  setData(d => ({
                    ...d,
                    projectNotaBarangFoto: {
                      ...d.projectNotaBarangFoto,
                      value: array
                    }
                  }))
                  // fnRefreshNotaIndex();
                }}

                fnClickPhoto={(object) => fnClickPhoto({
                  images: object.images,
                  title: object.title,
                  index: object.index,
                  fieldName: object.fieldName,
                })}
              />
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <DiskonBlock
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  dataDiscountVoucher: data.dataSelector.discountVoucher,

                  diskonId: data.projectCustomer.value.diskonId,
                  diskonFlag: data.projectCustomer.value.diskonFlag,
                  diskonName: data.projectCustomer.value.diskonName,
                  diskonType: data.projectCustomer.value.diskonType,
                  diskonValue: data.projectCustomer.value.diskonValue,
                  diskonDeductedFrom: data.projectCustomer.value.diskonDeductedFrom,
                  diskonVoucherCode: data.projectCustomer.value.diskonVoucherCode,
                }}

                fnOnChange={(obj) => {
                  setData(d => ({
                    ...d,
                    projectCustomer: {
                      ...d.projectCustomer,
                      value: {
                        ...d.projectCustomer.value,
                        diskonId: obj.diskonId,
                        diskonFlag: obj.diskonFlag,
                        diskonName: obj.diskonName,
                        diskonType: obj.diskonType,
                        diskonValue: obj.diskonValue,
                        diskonDeductedFrom: obj.diskonDeductedFrom,
                        diskonVoucherCode: obj.voucherCode
                      }
                    }
                  }));

                  fnRefreshStepSelesai();
                }}

                fnOnChangeVoucherCode={(obj) => {
                  setData(d => ({
                    ...d,
                    projectCustomer: {
                      ...d.projectCustomer,
                      value: {
                        ...d.projectCustomer.value,
                        diskonVoucherCode: obj.diskonVoucherCode
                      }
                    }
                  }));

                  fnRefreshStepSelesai();
                }}
              />
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <BarangDPBiaya
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaDPBiaya,
                }}

                fnOnChange={(dp, metode) => {
                  setData(d => ({
                    ...d,
                    projectNotaDPBiaya: {
                      ...d.projectNotaDPBiaya,
                      value: Number(dp) === 0 ? '' : dp
                    },
                    projectNotaDPMetode: {
                      ...d.projectNotaDPMetode,
                      value: safeValue(metode, '')
                    }
                  }))

                  fnRefreshStepSelesai();
                  // fnRefreshNotaIndex();
                }}
              />

              {Number(data.projectNotaDPBiaya.value) !== 0 &&
                <Box mt='1rem'>
                  <BarangDPBiayaMetode
                    stateData={{
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: stateUtilsRef.projectProcess,
                      projectIsCancel: stateUtilsRef.projectIsCancel,
                      userAccess: stateUtilsRef.userAccess,

                      data: data.projectNotaDPMetode,
                    }}

                    fnOnChange={(metode) => {
                      setData(d => ({
                        ...d,
                        projectNotaDPMetode: {
                          ...d.projectNotaDPMetode,
                          value: safeValue(metode, '')
                        }
                      }))
                      // fnRefreshNotaIndex();
                    }}
                  />
                </Box>
              }
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <RekomendasiPenerima
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaRekomendasiPengerjaan,
                  dataTeknisi: data.dataSelector.teknisi
                }}

                fnOnChange={(object) => {
                  object === null ?
                    setData(d => ({
                      ...d,
                      projectNotaRekomendasiPengerjaan: {
                        ...d.projectNotaRekomendasiPengerjaan,
                        value: constProjectNotaRekomendasiPengerjaan.value
                      },
                      projectNotaRekomendasiCatatan: {
                        ...d.projectNotaRekomendasiCatatan,
                        value: ''
                      }
                    }))
                    :
                    setData(d => ({
                      ...d,
                      projectNotaRekomendasiPengerjaan: {
                        ...d.projectNotaRekomendasiPengerjaan,
                        value: {
                          ...d.projectNotaRekomendasiPengerjaan.value,
                          id: object.id,
                          name: object.name,
                          gender: object.gender,
                          level: object.level,
                          subLevel: object.subLevel,
                        }
                      }
                    }));

                  fnRefreshNotaIndex();
                }}
              />

              {data.projectNotaRekomendasiPengerjaan.value.id &&
                <Box mt='1rem'>
                  <RekomendasiPenerimaInfo
                    stateData={{
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: stateUtilsRef.projectProcess,
                      projectIsCancel: stateUtilsRef.projectIsCancel,
                      userAccess: stateUtilsRef.userAccess,

                      data: data.projectNotaRekomendasiCatatan,
                    }}

                    fnOnChange={(val) => {
                      setData(d => ({
                        ...d,
                        projectNotaRekomendasiCatatan: {
                          ...d.projectNotaRekomendasiCatatan,
                          value: val
                        }
                      }))
                      fnRefreshNotaIndex();
                    }}
                  />
                </Box>
              }
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <Box mb='1.5rem'>
                <TanggalMasukProject
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectNotaTanggalMasuk,
                  }}

                  fnOnChange={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaTanggalMasuk: {
                        ...d.projectNotaTanggalMasuk,
                        value: sqlDateToIsoDate(safeValue(val, ''), new Date())
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </Box>

              <Box mb='1rem'>
                <DateLinePengecekan
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectNotaDateLinePengecekan,
                    minDate: data.projectNotaTanggalMasuk.value,
                  }}

                  fnOnChange={(arr) => {
                    setData(d => ({
                      ...d,
                      projectNotaDateLinePengecekan: {
                        ...d.projectNotaDateLinePengecekan,
                        error: '',
                        value: Array.isArray(arr) && (arr.length > 0) ? sqlDateToIsoDate(safeValue(arr[0].date_line_pengecekan, null), null) : null,

                        hasPengecekan: Array.isArray(arr) && (arr.length > 0) ? arr[0].has_pengecekan : null,
                        today: Array.isArray(arr) && (arr.length > 0) ? arr[0].today : null,
                        dateLine: Array.isArray(arr) && (arr.length > 0) ? arr[0].date_line_pengecekan : null,
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />

                <DeadlinePengecekan
                  stateMT=".5rem"
                  stateToday={data.projectNotaDateLinePengecekan.today}
                  stateDeadlinePengecekan={data.projectNotaDateLinePengecekan.dateLine}
                  stateHasPengecekan={data.projectNotaDateLinePengecekan.hasPengecekan}
                />
              </Box>

              <Box mb='1.5rem'>
                <DateLineSelesai
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectNotaDateLineSelesai,
                    minDate: data.projectNotaDateLinePengecekan.value,
                  }}

                  fnOnChange={(arr) => {
                    setData(d => ({
                      ...d,
                      projectNotaDateLineSelesai: {
                        ...d.projectNotaDateLineSelesai,
                        error: '',
                        value: Array.isArray(arr) && (arr.length > 0) ? sqlDateToIsoDate(safeValue(arr[0].date_line_selesai, null), null) : null,

                        today: Array.isArray(arr) && (arr.length > 0) ? arr[0].today : null,
                        dateLine: Array.isArray(arr) && (arr.length > 0) ? arr[0].date_line_selesai : null,
                        tanggalSelesai: Array.isArray(arr) && (arr.length > 0) ? arr[0].tanggal_selesai : null,
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />

                <DeadlineSelesai
                  stateMT=".5rem"
                  stateToday={data.projectNotaDateLineSelesai.today}
                  stateDeadlineSelesai={data.projectNotaDateLineSelesai.dateLine}
                  stateTanggalSelesai={data.projectNotaDateLineSelesai.tanggalSelesai}
                />
              </Box>

              <Box mb='1.5rem'>
                <PriorityNota
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    userAccess: stateUtilsRef.userAccess,

                    data: data.projectNotaPriority,
                  }}

                  fnOnChange={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaPriority: {
                        ...d.projectNotaPriority,
                        value: safeValue(val, '')
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </Box>

              <JenisService
                stateData={{
                  data: data.projectJenisService,
                }}
              />
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <ProjectNotaCatatan
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaCatatan,
                }}

                fnOnChange={(val) => {
                  setData(d => ({
                    ...d,
                    projectNotaCatatan: {
                      ...d.projectNotaCatatan,
                      value: safeValue(val, '')
                    }
                  }))
                  // fnRefreshNotaIndex();
                }}
              />
            </PaperWrapper>
          </Box>

          <Box mb='1rem'>
            <PaperWrapper>
              <Text
                size='sm'
                fw='bold'
              >
                Kelengkapan Barang
              </Text>

              <Divider my='sm' />

              <PrintKelengkapanPDF
                stateData={{
                  projectId: data.projectNotaNomor.value.id,
                  projectProcess: stateUtilsRef.projectProcess,
                  projectIsCancel: stateUtilsRef.projectIsCancel,
                  userAccess: stateUtilsRef.userAccess,

                  data: data.projectNotaBarangKelengkapan,
                  barangNama: data.projectNotaBarangNama.value,
                  kerusakan: data.projectNotaBarangKeluhan.value,
                  customer: data.projectCustomer.value.name,
                  tanggalMasuk: data.projectNotaTanggalMasuk.value,
                }}
              />
            </PaperWrapper>
          </Box>

          {canAccessTandaTerima({ stateObject: { subLevel: loginContext } }) && stepsCanAccessTandaTerima({ stateActualStep: stateUtilsRef.projectProcess }) &&
            <Box mb='xs'>
              <PaperWrapper>
                <Text
                  size='sm'
                  fw='bold'
                >
                  Tanda Terima
                </Text>

                <Divider my='sm' />

                <TandaTerimaComponent
                  stateDT={{
                    projectId: data.projectNotaNomor.value.id,
                    projectStep: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    caption: 'TANDA TERIMA'
                  }}
                />

                <Box>
                  <CustomerSignature
                    fnSuccessChange={(val) => {
                      setData(d => ({
                        ...d,
                        projectCustomer: {
                          ...d.projectCustomer,
                          value: {
                            ...d.projectCustomer.value,
                            signature: val
                          }
                        }
                      }))
                    }}

                    fnSuccessChangeName={(val) => {
                      setData(d => ({
                        ...d,
                        projectCustomer: {
                          ...d.projectCustomer,
                          value: {
                            ...d.projectCustomer.value,
                            signatureName: val
                          }
                        }
                      }))
                    }}

                    stateData={{
                      customerId: data.projectCustomer.value.id,
                      projectId: data.projectNotaNomor.value.id,
                      projectStep: stateUtilsRef.projectProcess,
                      projectIsCancel: stateUtilsRef.projectIsCancel,
                      projectCustomerSign: data.projectCustomer.value.signature,
                      projectCustomerSignName: data.projectCustomer.value.signatureName,
                    }}
                  />
                </Box>
              </PaperWrapper>
            </Box>
          }

          {canAccessInvoiceDanBuktiBayar({ stateObject: { subLevel: loginContext } }) && stepsCanAccessInvoice({ stateActualStep: stateUtilsRef.projectProcess }) &&
            <Box>
              <PaperWrapper>
                <Text
                  size='sm'
                  fw='bold'
                >
                  Invoice
                </Text>

                <Divider my='sm' />

                <INVBBComponent
                  stateDT={{
                    projectId: data.projectNotaNomor.value.id,
                    projectStep: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    caption: 'INVOICE',
                    jenisDokumen: utils.jenisDokumen.invoice.value,
                  }}
                />
              </PaperWrapper>
            </Box>
          }

          {canAccessInvoiceDanBuktiBayar({ stateObject: { subLevel: loginContext } }) && stepsCanAccessBuktiBayar({ stateActualStep: stateUtilsRef.projectProcess }) &&
            <Box mt='xs'>
              <PaperWrapper>
                <Text
                  size='sm'
                  fw='bold'
                >
                  Bukti Pembayaran
                </Text>

                <Divider my='sm' />

                <INVBBComponent
                  stateDT={{
                    projectId: data.projectNotaNomor.value.id,
                    projectStep: stateUtilsRef.projectProcess,
                    projectIsCancel: stateUtilsRef.projectIsCancel,
                    caption: 'BUKTI PEMBAYARAN',
                    jenisDokumen: utils.jenisDokumen.buktiBayar.value,
                  }}
                />
              </PaperWrapper>
            </Box>
          }
        </Box>
      }
    </React.Fragment>
  )
}

export default React.memo(StepNota);